import Model from './Model'

export default class Education extends Model {
  resource() {
    return 'education/videos'
  }
}
